import { atom } from "recoil";
import { UpdateCategoryIRoute } from "../generated/Api";

export const CategoriesAtom = atom<UpdateCategoryIRoute[]>({
  key: "CategoriesAtom",
  default: [],
});

export const IsCheckedAllCategoriesAtom = atom<boolean>({
  key: "IsCheckedAllCategoriesAtom",
  default: false,
});

export const CategoriesSearchAtom = atom({
  key: "CategoriesSearchAtom",
  default: "",
});
